import type { ModuleDefinition } from '@core/router/types';
import { documentArchiveRoutes } from './routes';
import { documentArchiveNavigation, documentArchiveModuleInfo } from './navigation';

export const documentArchiveModule: ModuleDefinition = {
  name: 'arhiva-dokumenata',
  basePath: '/arhiva-dokumenata',
  routes: documentArchiveRoutes,
  navigation: documentArchiveNavigation,
  moduleInfo: documentArchiveModuleInfo,
};

export default documentArchiveModule;
